import { useEffect, useRef } from 'react';

/** Refresh a visible connected view; never overlap refreshes or retain work after unmount. */
export default function useVisibleRefresh(refresh, enabled = true) {
  const running = useRef(false);
  useEffect(() => {
    if (!enabled) return undefined;
    let stopped = false;
    const run = async () => {
      if (stopped || running.current || document.visibilityState === 'hidden' || navigator.onLine === false) return;
      running.current = true;
      try { await refresh({ background: true }); } catch { /* The view owns its authored error message. */ }
      finally { running.current = false; }
    };
    const timer = setInterval(run, 30000);
    window.addEventListener('focus', run);
    window.addEventListener('online', run);
    document.addEventListener('visibilitychange', run);
    return () => {
      stopped = true;
      clearInterval(timer);
      window.removeEventListener('focus', run);
      window.removeEventListener('online', run);
      document.removeEventListener('visibilitychange', run);
    };
  }, [refresh, enabled]);
}
